<template>
    <ModalBase
        :name="'editar-codigo-' + codigo.id"
        title="Editar código de invitación"
        @close="close"
        :width="480"
    >
        <ValidationObserver tag="form" ref="observer" class="tw:space-y-4" @submit.prevent="onSubmit">
            <!-- Vista de solo-lectura del código (no se edita) -->
            <div class="tw:rounded-lg tw:bg-slate-50 tw:border tw:border-slate-200 tw:px-4 tw:py-3">
                <p class="tw:text-xs tw:text-slate-500 tw:font-semibold tw:uppercase tw:tracking-wider tw:mb-1">Código</p>
                <p class="tw:font-mono tw:text-sm tw:text-slate-900">{{ codigo.codigo }}</p>
            </div>

            <BaseInputNumber
                v-model="usos"
                name="usos"
                label="Usos"
                :min="0"
                :step="1"
                rules="required|min_value:0"
            />
        </ValidationObserver>

        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2">
                <Button variant="ghost" @click="close" :disabled="loading">Cancelar</Button>
                <Button variant="primary" type="button" :loading="loading" @click="onSubmit">Actualizar</Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref, getCurrentInstance } from 'vue';
    import store from '@/store';
    import { config } from '@/config.js';
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import BaseInputNumber from '@/modules/admin/ui/BaseInputNumber.vue';
    import Button from '@/modules/admin/ui/Button.vue';
    import { useToast } from '@/composables/common/useToast';

    const props = defineProps({
        codigo: { type: Object, required: true },
        listaId: { type: [String, Number], required: true },
        categoriaId: { type: [String, Number], required: true }
    });

    const emit = defineEmits(['close', 'editado']);
    const instance = getCurrentInstance();
    const toast = useToast();
    const observer = ref(null);
    const usos = ref(props.codigo?.usos ?? 0);
    const loading = ref(false);

    function close() {
        instance.proxy.$modal.hide('editar-codigo-' + props.codigo.id);
        emit('close');
    }

    async function onSubmit() {
        const isValid = await observer.value.validate();
        if (!isValid) return;

        loading.value = true;
        try {
            await store.dispatch(
                config.getVuexAlias('back.bases.categorias.codigos_invitacion.editar'),
                {
                    lista_id: props.listaId,
                    categoria_id: props.categoriaId,
                    codigo_id: props.codigo.id,
                    usos: usos.value
                }
            );
            toast.success('Usos editados correctamente.');
            emit('editado');
            close();
        } catch (error) {
            console.error('Error editing codigo:', error);
            toast.error(error.response?.data?.message || 'Error al editar el código');
        } finally {
            loading.value = false;
        }
    }
</script>
